export enum GROUP_TYPE {
  DEVICE = 'device',
  BROWSER = 'browser',
  OFFER = 'offer',
  COUNTRY = 'country',
  PROVIDER = 'provider',
  OS = 'os',
  CONNECTION_TYPE = 'connectionType',
  CAMPAIGN = 'campaign',
  SITE_ID = 'siteId',
}
